module.exports = __webpack_public_path__ + "img/header-reagenzglas.85ce5fc4.jpg";